import { PrismicRichText } from "@prismicio/react";
import { Link } from "gatsby";
import React, {useState} from "react";
import { Tooltip } from "react-tooltip";
import { colorCheck } from "../../utils/accessibility-helpers";
import { ControlledAccordion, AccordionItem, useAccordionProvider } from "@szhsin/react-accordion";

function Table({sc, fea}) {
  return (
    <>
      {sc.section_title.text ? (
        <div className="wrapper">
          <div className="md:text-center md:w-4/5 md:m-auto">
            <PrismicRichText field={sc.section_title.richText} />
          </div>
        </div>
      ) : ''}
      <div className="wrapper">
        <div className="comps flex w-full text-center justify-end">
          <div className="hidden md:block pt-6 md:pt-8 px-6 md:px-8 text-normal w-1/4">
            <PrismicRichText field={sc.comp_one.richText} />
            <Link
              to={sc.comp_one_button_link.url}
              className={"btn bg-" + colorCheck(sc.comp_one_theme)}
            >
              {sc.comp_one_button_label}
            </Link>
          </div>
          <div className="hidden md:block pt-6 md:pt-8 px-6 md:px-8 w-1/4">
            <PrismicRichText field={sc.comp_two.richText} />
            <Link
              to={sc.comp_two_button_link.url}
              className={"btn bg-" + colorCheck(sc.comp_two_theme)}
            >
              {sc.comp_two_button_label}
            </Link>
          </div>
        </div>
        {fea.map((f, index) => {
          return (
            <table
              key={index}
              className="hidden md:table text-left border-spacing-8 border-collapse w-full"
            >
              <colgroup>
                <col className="w-1/2" />
                <col className="w-1/4" />
                <col className="w-1/4" />
              </colgroup>
              <caption className="pt-8 pb-4 !font-bold text-xl text-left border-b border-grey-md">
                {f.feature_section.document.data.type_of_service}
              </caption>
              <tbody className="th">
                {f.feature_section.document.data.features.map((info, index) => {
                  return (
                    <tr key={index}>
                      <th scope="row">
                        {info.feature}
                        {info.tooltip ? (
                          <a
                            data-tooltip-id="my-tooltip"
                            data-tooltip-content={info.tooltip_content.text}
                          >
                            <i className="fa-solid fa-circle-question opacity-30" />
                            <Tooltip id="my-tooltip" place="right" />
                          </a>
                        ) : (
                          ""
                        )}
                      </th>
                      <td>
                        {info.comp_one ? (
                          <div>
                            <p className="sr-only">
                              Quantum Health Access&trade; offers {info.feature}
                            </p>
                            <i
                              role="presentation"
                              className={
                                "fa-solid fa-check text-" +
                                colorCheck(sc.comp_one_theme)
                              }
                            />
                          </div>
                        ) : (
                          <div>
                            <p className="sr-only">
                              Quantum Health Access&trade; does not offer{" "}
                              {info.feature}
                            </p>
                            <i
                              role="presentation"
                              className="fa-solid fa-minus text-grey-md"
                            />
                          </div>
                        )}
                      </td>
                      <td>
                        {info.comp_two ? (
                          <div>
                            <p className="sr-only">
                              Quantum Health Complete&trade; offers{" "}
                              {info.feature}
                            </p>
                            <i
                              role="presentation"
                              className={
                                "fa-solid fa-check text-" +
                                colorCheck(sc.comp_two_theme)
                              }
                            />
                          </div>
                        ) : (
                          <div>
                            <p className="sr-only">
                              Quantum Health Complete&trade; does not offer{" "}
                              {info.feature}
                            </p>
                            <i
                              role="presentation"
                              className="fa-solid fa-minus text-grey-md"
                            />
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          );
        })}
        <div className="md:hidden">
          <div className="feature">
            <div className="flex flex-wrap gap-2 justify-between items-center">
              <div className={"title text-" + colorCheck(sc.comp_one_theme)}>
                <PrismicRichText field={sc.comp_one.richText} />
              </div>
              <Link
                to={sc.comp_one_button_link.url}
                className={"btn bg-" + colorCheck(sc.comp_one_theme)}
              >
                {sc.comp_one_button_label}
              </Link>
            </div>
            <div className="comp">
              <div className="pt-8 pb-4 !font-bold text-lg">
                {fea[0].feature_section.document.data.type_of_service}
              </div>
            </div>
            <ul className="th">
              {fea[0].feature_section.document.data.features.map(
                (info, index) => {
                  return (
                    <li
                      key={index}
                      className="border-t border-grey-light py-3 text-sm"
                    >
                      {info.comp_one || info.comp_two ? (
                        <div className="flex items-center">
                          <i
                            className={
                              "text-xl fa-solid fa-check mr-4 text-" +
                              colorCheck(sc.comp_one_theme)
                            }
                          />
                          {info.feature}
                          {info.tooltip ? (
                            <a
                              data-tooltip-id="my-tooltip"
                              data-tooltip-content={info.tooltip_content.text}
                            >
                              <i className="ml-2 fa-solid fa-circle-question opacity-30" />
                              <Tooltip id="my-tooltip" place="right" />
                            </a>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </li>
                  );
                }
              )}
            </ul>
          </div>
          <div className="feature">
            <div className="flex flex-wrap gap-2 justify-between items-center pb-8">
              <div className={"title text-" + colorCheck(sc.comp_two_theme)}>
                <PrismicRichText field={sc.comp_two.richText} />
              </div>
              <Link
                to={sc.comp_two_button_link.url}
                className={"btn bg-" + colorCheck(sc.comp_two_theme)}
              >
                {sc.comp_two_button_label}
              </Link>
            </div>
            <div
              className={
                "flex items-center text-" + colorCheck(sc.comp_one_theme)
              }
            >
              <i className="text-xl fa-solid fa-check mr-4" />
              <PrismicRichText
                field={fea[1].feature_section.document.data.content.richText}
              />
            </div>
            <div className="comp">
              <div className="py-4 !font-bold text-lg">
                {fea[1].feature_section.document.data.type_of_service}
              </div>
            </div>
            <ul className="th">
              {fea[1].feature_section.document.data.features.map(
                (info, index) => {
                  return (
                    <li
                      key={index}
                      className="border-t border-grey-light py-3 text-sm"
                    >
                      {info.comp_one || info.comp_two ? (
                        <div className="flex items-center">
                          <i
                            className={
                              "text-xl fa-solid fa-check mr-4 text-" +
                              colorCheck(sc.comp_two_theme)
                            }
                          />
                          {info.feature}
                          {info.tooltip ? (
                            <a
                              data-tooltip-id="my-tooltip"
                              data-tooltip-content={info.tooltip_content.text}
                            >
                              <i className="ml-2 fa-solid fa-circle-question opacity-30" />
                              <Tooltip id="my-tooltip" place="right" />
                            </a>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </li>
                  );
                }
              )}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

export const CompTable = (props) => {
  const sc = props.slice.primary;

  const fea = props.slice.items;

  const anchor = sc.section_title.text.replace(/\s+/g, "-").toLowerCase();

  const [button, showButton] = useState(false)

  const providerValue = useAccordionProvider({
    allowMultiple: true,
    transition: true,
    transitionTimeout: 250
  });

  const { toggleAll } = providerValue;

  const toggleBtn = () => {
    showButton(true)
  }

  const handle = () => {
    toggleBtn();
    toggleAll();
  }

  return (
    <section id={anchor} className="relative gutter top">
    {sc.expand ? <>
      <div className="wrapper flex justify-center">{button ? '' : <button className="btn-acc" onClick={handle}>{sc.expanded_button_label}</button>}</div>
      <ControlledAccordion providerValue={providerValue}><AccordionItem><Table sc={sc} fea={fea} anchor={anchor} /></AccordionItem></ControlledAccordion>
    </> : <Table sc={sc} fea={fea} /> }
    </section>
    
  );
};


